import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories, ARTICLE_SLUG } from "@/constants/site";

export default function Footer() {
  const { t } = useTranslation();
  const { lang = "en" } = useParams();

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-grid-line text-base leading-none" />
              </span>
              <span className="text-base font-bold tracking-tight text-foreground-950">
                {t("brand.name")}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              {t("footer.description")}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t("categories.title")}</h4>
            <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2">
              {categories.map((c) => (
                <a
                  key={c.key}
                  href={c.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t(`categories.${c.key}`)}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t("footer.resources")}</h4>
            <ul className="mt-4 space-y-2">
              <li>
                <Link
                  to={`/${lang}/article/${ARTICLE_SLUG}`}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t("nav.guides")}
                </Link>
              </li>
              <li>
                <span className="text-sm text-foreground-500">{t("footer.languages")}:</span>
              </li>
              <li className="flex flex-wrap gap-2 pt-1">
                {["en", "fr", "de", "es", "pt"].map((code) => (
                  <Link
                    key={code}
                    to={`/${code}`}
                    className="rounded-md border border-background-300/60 bg-background-50 px-2.5 py-1 text-xs font-medium uppercase text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {code}
                  </Link>
                ))}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-background-200 pt-6 sm:flex-row sm:items-center">
          <p className="text-sm text-foreground-500">{t("footer.copyright")}</p>
          <p className="text-xs text-foreground-400">{t("footer.disclaimer")}</p>
        </div>
      </div>
    </footer>
  );
}